import { ReportModel } from "./ReportModel";

export class ReportViewModel {
    report: ReportModel;
    groupsNames: string[];
}


// WEBPACK FOOTER //
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/src/app/shared/classes/ReportViewModel.ts